import React from 'react';
import { message } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { green, orange } from '@ant-design/colors';
import moment from 'moment';
import API from '../../../../../API';
import { CONFIRM_BDO_CARD_COMMAND_TYPE, ConfirmBdoCardCommand } from 'types/commands';
import { OrderType, User, UserLevel } from 'types';
import { useUserLevel } from 'reducers';
import { AsyncButton } from 'components';

interface Props {
	orderType: OrderType.classic | OrderType.loose;
	orderId: number;
	confirmedAt: string | null;
	confirmedBy: User | null;
	onConfirmed: () => Promise<unknown>;
}

export const BdoCardPanel: React.FC<Props> = ({ orderType, orderId, confirmedAt, confirmedBy, onConfirmed }) => {
	const userLevel = useUserLevel() ?? UserLevel.driver;

	const handleConfirm = async () => {
		try {
			const command: ConfirmBdoCardCommand = {
				orderId,
				orderType,
			};
			await API.sendCommand(CONFIRM_BDO_CARD_COMMAND_TYPE, command);
			await onConfirmed();
		} catch (e) {
			message.error('Wystąpił błąd');
			console.trace(e);
		}
	};

	if (confirmedAt && confirmedBy) {
		return (
			<span style={{ color: green[5], fontSize: '0.75em' }}>
				<div className="flex flex-dir">
					<span className="flex gap-2">
						<CheckCircleOutlined style={{ color: green[5] }} />
						{moment(confirmedAt).format('DD.MM.YYYY HH:mm')}
					</span>
					<span>
						({confirmedBy.name} {confirmedBy.surname})
					</span>
				</div>
			</span>
		);
	}

	if (userLevel >= UserLevel.superAdmin) {
		return <AsyncButton onClick={handleConfirm}>Potwierdź kartę BDO</AsyncButton>;
	}

	return <span style={{ color: orange[5], fontSize: '0.75em' }}>Oczekuje na potwierdzenie karty BDO</span>;
};
